import gql from 'graphql-tag';

import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { TrackPromotionShareMutation, TrackPromotionShareMutationVariables } from './api.graphql';

type Input = { token: string; placement?: string; algorithm?: string; countryCode: string };
type QueryData = TrackPromotionShareMutation;
type QueryVariables = TrackPromotionShareMutationVariables;

const query = gql`
	mutation TrackPromotionShare($input: TrackPromotedEventInput!) {
		trackPromotedEvent(input: $input) {
			success
		}
	}
`;

export async function trackPromotionShare(
	{ token, placement, algorithm, countryCode }: Input,
	{ gql: { fetch } }: UtilityContext,
	{
		silent,
	}: {
		// if true, won't throw on error
		silent?: boolean;
	} = {},
): Promise<void> {
	let data: QueryData | null | undefined;
	try {
		const result = await fetch<QueryData, QueryVariables>({
			query,
			variables: {
				input: {
					eventType: 'SHARE',
					promotionToken: token,
					placement: placement || null,
					algorithm,
					countryCode,
				},
			},
			important: true,
		});
		({ data } = result);
	} catch (err) {
		if (silent) return;
		throw new Error('Promotion tracking failed');
	}

	if (silent) return;
	if (!data?.trackPromotedEvent.success) {
		throw new Error('Promotion tracking failed');
	}
}
